import { useEffect } from "react";
import cn from "classnames";
import { IntrinsicElements } from "types/intrinsicElements.types";
import { useOpenState } from "../context/SelectContext";
import styles from "../Select.module.scss";

type SelectBodyProps = IntrinsicElements["div"] & {
  beforeBodyClose?: () => void;
};

export const SelectBody = ({ children, className, beforeBodyClose, ...props }: SelectBodyProps) => {
  const [isOpen] = useOpenState();

  useEffect(() => {
    if (isOpen) return;
    beforeBodyClose?.();
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div aria-label="select-body" data-clickable="clickable" className={cn(styles.body, className)} {...props}>
      {children}
    </div>
  );
};
